export const IDS = {
  organizationTypes: {
    Retailer: '5c94f6a2-f82b-437c-9a99-a54544d75ff0',
    Distributor: '138c5098-41ff-45c7-b08a-98c0cae54a17',
    Dealer: '5232242e-a439-4f62-b292-ec711f4e0656',
  },
  userTypes: {
    Owner: '121380be-fde4-4b3b-a6aa-98b543d529cf',
    Driver: '4f0d486f-436b-4714-bcd5-5de71211cdfa',
    Employee: '75475cf8-bbb4-457a-bbe1-47914cd1bad3',
    Manager: 'd57c973a-43e3-4f9b-bf52-bed58663c0cb',
    Customer: '4d6c0797-b970-444d-b51d-f8f042e1df09'
  },
  vehicleType: {
    Tempo: 'TEMPO',
    Truck: 'TRUCK',
  },
  orderSystem: {
    ReadyStock: 1,
    PreOrder: 2
  },
  unitType: {
    Box: '42bb06ee-02dc-4192-9333-e7b95e6b7f72',
    Piece: '668741ca-f430-408f-b69c-1a4a9f0ed7a6',
  },
  userPriceList: {
    DistributorSurat: 'a2c4fa46-cc1c-4896-ba4b-9b6b4d321483',
    DealerSurat: '069a085f-6981-4c45-9712-aa16ebf395f8',
    RetailerSurat: '96bef4ac-4699-4006-ac6f-99dccb435e20',
  },
  orderStatus: {
    AccountVerification: '1efd25a9-0497-4179-acc6-7b8a06739981',
    PendingForDispatch: 'e462073c-b220-44a1-8e20-90f87910ff96',
    Dispatched: '9ab2279d-afb0-45ac-a20e-024721130337',
    Delivered: 'e1db99dc-ab53-4ca0-84ef-b85db77dae9d',
    Rejected: '90abf86d-8fbd-42d7-82d6-262689b70e4b',
    Canceled: '57615d55-454b-488b-8b65-25617daf6027',
  },
  TripOrderStatus: {
    OrderPlaced: '40619378-32c4-42ae-8cc2-52e1453c2fc9',
    Dispatched: '7c83925c-f790-4ed2-beeb-f4bb49b8ee32',
    Delivered: '87551d9d-b04a-4ba1-9ac0-d12751e8d2da',
  },
  TripStatus: {
    NotStarted: '2c0ad91e-614d-44d0-aed3-3f45e08a8651',
    InProgress: '43730f36-851f-4297-9e1b-5695431206a4',
    Paused: '11900769-7c8b-4e4e-a9b1-e7f534cd5f48',
    Completed: 'e84656a0-75e8-4a9b-845d-ee978fd53301',
    Dispatched: '4f0a1525-8779-4c1b-8c02-1ed505a6fc94',
    Delivered: '27c56d65-5347-4ff0-bb2f-7dfe73266669',
    Unloaded: '18f0919a-6038-43aa-941d-9c80061055d8',
    UnloadedWithOpening: '802ffc65-e6df-420f-b55d-1a0d8adbd348'
  },
  organizations: {
    RAJ_WAFERS_MASTER: '1d49a2fe-ca28-41bc-9bc5-76331d5e0416',
  },
  DUMMY_ID: '74eed96c-0751-4559-90eb-0e3f3ea27b21',
  PreOrderSalesBy: {
    PilotSalesman: 1,
    Self: 2
  },
}

IDS['OrderStatusColor'] = {
  [IDS.orderStatus.AccountVerification]: '#05399e',
  [IDS.orderStatus.PendingForDispatch]: '#fa9600',
  [IDS.orderStatus.Dispatched]: '#1892ad',
  [IDS.orderStatus.Delivered]: '#09974a',
  [IDS.orderStatus.Canceled]: '#fc2b2b',
  [IDS.orderStatus.Rejected]: '#c31807',
  'DEFAULT': '#000000'
}

IDS['TripOrderStatusColor'] = {
  [IDS.TripOrderStatus.OrderPlaced]: '#fa9600',
  [IDS.TripOrderStatus.Dispatched]: '#1892ad',
  [IDS.TripOrderStatus.Delivered]: '#09974a',
  'DEFAULT': '#000000'
}

IDS['TripStatusColor'] = {
  [IDS.TripStatus.NotStarted]: '#05399e',
  [IDS.TripStatus.InProgress]: '#8F00FF',
  [IDS.TripStatus.Paused]: '#D4AF37',
  [IDS.TripStatus.Completed]: '#FA9600',
  [IDS.TripStatus.Dispatched]: '#06B6D4',
  [IDS.TripStatus.Delivered]: '#059669',
  'DEFAULT': '#000000'
}
